import * as R from 'ramda'
import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import clsx from 'clsx'
import { Typography, Button } from '@material-ui/core'

import { PlanBillingCancelPlan } from './PlanBillingCancelPlan'
import { PlanBillingCreditCard } from './PlanBillingCreditCard'
import { PlanBillingPaymentMethodFormDialog } from './PlanBillingPaymentMethodFormDialog'
import { PlanBillingPaypalCard } from './PlanBillingPaypalCard'

export const CardType = {
  CREDIT_CARD: 'CreditCard',
  PAYPAL: 'PayPalAccount',
}

const getPaymentMethodType = (paymentMethod) => {
  if (R.prop('type', paymentMethod) === CardType.PAYPAL) {
    return CardType.PAYPAL
  }

  return CardType.CREDIT_CARD
}

export const PlanBillingPaymentMethod = (props) => {
  const [isOpenChangePaymentMethodDialog, setIsOpenChangePaymentMethodDialog] =
    useState(false)
  const { formatMessage } = useIntl()

  return (
    <>
      <div className="sm:flex justify-between items-center">
        <Typography variant="subtitle1" className={clsx('flex-1 font-bold')}>
          {formatMessage({ id: 'planAndBilling.paymentMethod.label' })}
        </Typography>
        <div className="space-x-5 flex justify-end">
          {props.isCancelPlan ? <PlanBillingCancelPlan /> : null}

          <Button
            onClick={() => {
              setIsOpenChangePaymentMethodDialog(true)
            }}
            variant="contained"
            className="bg-white self-start text-blue-primary border-solid border-1 border-blue-primary shadow-0"
            data-testid="changePaymentMethodButton"
          >
            {formatMessage({ id: 'action.update' })}
          </Button>
        </div>
      </div>

      <PlanBillingPaymentMethodCard {...props} />
      <PlanBillingPaymentMethodFormDialog
        isOpen={isOpenChangePaymentMethodDialog}
        onClose={() => {
          setIsOpenChangePaymentMethodDialog(false)
        }}
      />
    </>
  )
}

export const PlanBillingPaymentMethodCard = (props) => {
  const { paymentMethod } = props
  return R.equals(getPaymentMethodType(paymentMethod), CardType.PAYPAL) ? (
    <PlanBillingPaypalCard email={R.prop('email', paymentMethod)} {...props} />
  ) : (
    <PlanBillingCreditCard
      {...props}
      cardBand={R.prop('cardType', paymentMethod)}
      cardLastFour={R.prop('last4', paymentMethod)}
      expirationMonth={Number(R.prop('expirationMonth', paymentMethod))}
      expirationYear={Number(R.prop('expirationYear', paymentMethod))}
    />
  )
}
